import { EnvModel } from "../models/env.model";
import { UserBookingDetailsModel, UserDetails } from "../models/user-booking-details.model";
import * as $http from '../helpers/jquery.helper';

const rememberMeKey = 'rememberMeState';
const rememberMeDetailsKey: string = 'tb-rememberme';

export default class RememberMeService {
  constructor(private env: EnvModel) { }

  public getRememberMeState(): boolean {
    const state = localStorage.getItem(rememberMeKey);

    return state === 'true';
  }

  public persistRememberMeDetails(isRemember: boolean, userDetails: UserDetails) {
    this.saveRememberMeState(isRemember);
    this.rememberUserDetails(isRemember, userDetails);
  }

  public saveRememberMeState(rememberMeState: boolean) {
    localStorage.setItem(rememberMeKey, rememberMeState.toString());
  }

  public rememberUserDetails(isRemember: boolean, userDetails: UserDetails) {
    if (isRemember) {
      localStorage.setItem(rememberMeDetailsKey, JSON.stringify(userDetails));
    } else {
      localStorage.removeItem(rememberMeDetailsKey);
    }
  }

  public getUserDetails(): UserDetails | null {
    var localUser = localStorage.getItem(rememberMeDetailsKey);

    if (localUser) {
      try {
        return JSON.parse(localUser) as UserDetails;
      } catch (e) {
        console.error(e);
      }
    }
    return null;
  }
}